import React from "react";
import * as clipboard from "clipboard-polyfill";

import { MapNode } from "./map";
import s from "./more.module.scss";
import sMap from "./map.module.scss";
import { background } from "@moai/core";

interface Props {
    node: MapNode;
    setFoo: (foo: null | boolean) => void;
}

export const MoreButton: React.FC<Props> = ({ node, setFoo }) => {
    const copy = React.useCallback(() => {
        clipboard.writeText(JSON.stringify(node)).catch((e) => {
            window.alert(`Cannot copy: ${e.message}`);
        });
    }, [node]);

    const expand = React.useCallback(() => {
        setFoo(true);
        window.setTimeout(() => setFoo(null), 500);
    }, [setFoo]);

    const collapse = React.useCallback(() => {
        setFoo(false);
        window.setTimeout(() => setFoo(null), 500);
    }, [setFoo]);

    const onChange = React.useCallback(
        (e: React.ChangeEvent<HTMLSelectElement>) => {
            switch (e.target.value) {
                case "copy":
                    return copy();
                case "expand":
                    return expand();
                case "collapse":
                    return collapse();
                default:
                    throw Error(`Unknown target: ${e.target.value}`);
            }
        },
        [copy, expand, collapse]
    );

    return (
        <select
            onChange={onChange}
            value="default"
            // select needs explicit background set for the menu
            className={`${s.more} ${sMap.more} ${background.primary}`}
        >
            <option value="default">…</option>
            <option value="copy">Copy</option>
            <option value="expand">Expand all</option>
            <option value="collapse">Collapse all</option>
        </select>
    );
};
